// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E1R7","placeholdersHeader":"styles_placeholdersHeader__18LVj","editorStyle":"styles_editorStyle__30WCr","placeholdersBox":"styles_placeholdersBox__3S_Gh"};